import { mutator } from 'satcheljs';
import { getAttachmentSuggestionsAction } from '../actions/publicLazyActions';
import getMRUAttachmentStore from '../store/mruAttachmentStore';
import { KEY_NULLREFERENCEITEMID } from '../utils/constants';

mutator(getAttachmentSuggestionsAction, actionMessage => {
    const { composeId } = actionMessage;
    const referenceItemId = actionMessage.referenceItem?.ItemId?.Id || KEY_NULLREFERENCEITEMID;
    const idMap = getMRUAttachmentStore().referenceItemIdAndComposeIdMap;
    const entries = idMap.get(referenceItemId);
    if (entries) {
        entries.push(composeId);
    } else {
        idMap.set(referenceItemId, [composeId]);
    }
});
